export const countryDefault = 'MU';
export const countries = [
  {
    name: "Singapore",
    code: "SG",
  },
  {
    name: "Mauritius",
    code: "MU",
  },
  {
    name: "Japan",
    code: "JP",
  },
  {
    name: "Europe",
    code: "EU",
  },
  {
    name: "Hong Kong",
    code: "HK",
  },
];


/**
 * 
 * @param {*} code 
 * @returns : country name, if not found returns empty string
 */
export const getCountryNameWithCountryCode = (code='MU')=>{
    let countryData = countries.find((x)=>x.code===code);
    if( !countryData ) {
        return 'Mauritius'
    }
    return countryData.name;
}

/**
 * 
 * @param {*} name 
 * @returns : country code, if not found returns empty string
 */
export const getCountryCodeWithCountryName = (name='Mauritius')=>{
    let countryData = countries.find((x)=>x.name===name);
    if( !countryData ) {
        return 'MU'
    }
    return countryData.code;
}